export function shortenText(text, chars = 10, notDots) {
  let result = ''

  if (text.length > chars) {
    result += text.substring(0, chars)
    if (!notDots) result += '...'
  } else result += text

  return result
}
